import React, { Component, Children, cloneElement } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import withRippleEffect from '../withRippleEffect';

class DropDownMenu extends Component {
	constructor(props) {
		super(props);

		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	render() {
		const { expanded } = this.props;

		return (
			<div className="drop-down-menu">
				{expanded &&
					<div
						className="drop-down-menu__items"
						onClick={this.props.onClose}
					>
						{this.props.children}
					</div>}
			</div>
		);
	}

	handleClickOutside() {
		this.props.onClose();
	}
}

export const DropDownMenuItem = ({ rippleContainerRef, onClick, children }) =>
	<div
		className="drop-down-menu__item"
		ref={rippleContainerRef}
		onClick={onClick}
	>
		{children}
	</div>;

export default enhanceWithClickOutside(DropDownMenu);



// WEBPACK FOOTER //
// ./src/js/Ui/DropDownMenu/DropDownMenu.jsx